import { render } from "./FlashStats.vue?vue&type=template&id=0f99b7a2"
import script from "./FlashStats.vue?vue&type=script&lang=js"
export * from "./FlashStats.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__